import React, { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeModal } from "../../../state/reducers/global";
import ModalInsert from "../../../views/components/ModalInsert";
import Panel from "../../../views/components/Panel";
import VendorVehiclePricingSummaryModal from "../../components/VendorVehiclePricingSummaryModal";
import { getPricingTypeDisplayName, getConditionDisplayValue } from "../../../shared/utility";
import { headerText, vehicleSummaryColumns, percentageSummaryColumns, monetarySummaryColumns, finalPriceSummaryColumns, DETAILS_TEXT, helpText } from "./const";


const VendorVehiclePricingSummaryModalContainer = () => {
  const dispatch = useDispatch();

  const onCancel = () => {
    dispatch(closeModal());
  };

  const vendorVehiclePricingSummaryData = useSelector((state) => state.vendorVehicleRecord.salesInformation.vehiclePricingSummary?.data);

  const pricingSummaryData = {
    requestType: getPricingTypeDisplayName(vendorVehiclePricingSummaryData?.pricingType) || "-",
    percentageDirection: vendorVehiclePricingSummaryData?.adjustmentType || "I",
    condition: getConditionDisplayValue(vendorVehiclePricingSummaryData?.vehicleCondition) || "Unknown",
    adjustedPercentagePrice: vendorVehiclePricingSummaryData?.adjustedPercentagePrice || 0,
    vehicleSummaryData: {
        vehicleType: vendorVehiclePricingSummaryData?.vehicleType || "-",
    },
    percentageSummaryData: {
        baseValuation: vendorVehiclePricingSummaryData?.baseValuation || "-",
        basePercentage: vendorVehiclePricingSummaryData?.basePercentage || 0,
        adjustment: vendorVehiclePricingSummaryData?.adjustmentPercentage || 0,
    },
    monetarySummaryData: {
      calculatedValue: vendorVehiclePricingSummaryData?.adjValuation,
      additionalAdjustment: vendorVehiclePricingSummaryData?.adjustmentFixed || 0,
      effectOnPrice: vendorVehiclePricingSummaryData?.adjustedPrice || 0,
    },
    finalPriceSummaryData: {
        finalPrice: vendorVehiclePricingSummaryData?.finalPrice || 0,
    },
  };

  return (
    <Fragment>
      <ModalInsert>
        <Panel
          style={{ height: "100%", borderRadius: "0.5rem" }}
          actions={[
            {
              content: "Close",
              action: onCancel,
              type: "ghost",
            },
          ]}
        >
        <VendorVehiclePricingSummaryModal 
          pricingSummaryData={pricingSummaryData}
          headerText={headerText}
          vehicleSummaryColumns={vehicleSummaryColumns}
          percentageSummaryColumns={percentageSummaryColumns}
          finalPriceSummaryColumns={finalPriceSummaryColumns}
          monetarySummaryColumns={monetarySummaryColumns}
          DETAILS_TEXT={DETAILS_TEXT}
          helpText={helpText}
        />          
        </Panel>
      </ModalInsert>
    </Fragment>
  );
};

export default VendorVehiclePricingSummaryModalContainer;
